import React, {FC} from "react";
import css from "./style.module.css";
import {isNullOrUndef} from "chart.js/helpers";

export interface IProps {
    value: number;
    style?: React.CSSProperties
}

const ValueWithPercent: FC<IProps> = ({value, style}) => {
    const colorByNumber = (val: number) => {
        return val > 0 ? "green" : val < 0 ? "red" : "yellow"
    }
    const renderValue = (val: number) => {
        if (isNullOrUndef(val)) {
            return "--";
        }

        let customizeVal = val.toFixed(2);

        if (val < 0) {
            // Remove the '-' char.
            customizeVal = customizeVal.substring(1);
        }

        return customizeVal;
    }


    return <>
        {!isNullOrUndef(value) ? <span className={css.percent}
                                style={{color: colorByNumber(value), ...style}}> %{renderValue(value)}</span>:'---'
        }
    </>
}


export default ValueWithPercent;